import {
  headerHeight
} from '../helpers';
import {
  atQuery
} from '../../scripts/components/mediaQueries';

if (!window.dAgency) window.dAgency = {};
$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0)
    return false;

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ======================== First section check ======================== */
  const firstSection = document.querySelector('section.shopify-section:first-of-type');
  const lowEnergyStrip = document.querySelector('.low-energy-bar__container');
  if (!lowEnergyStrip && firstSection && (firstSection.querySelector('.hero-banner-multiple__container') || firstSection.querySelector('.hero-slideshow__container') || firstSection.querySelector('.hero-parallax__container'))) {
    $header.addClass('header__transparent');
  }

  /* ======================== Header ======================== */
  if ($(window).scrollTop() === 0) {
    $header.addClass('apply-transparency');
  } else {
    $header.removeClass('apply-transparency');
  }

  $(window).on('scroll', function () {
    if (!$header.hasClass('force-opacity')) {
      if ($(window).scrollTop() === 0) {
        $header.addClass('apply-transparency');
      } else {
        $header.removeClass('apply-transparency');
      }
    }
  });

  $header.on('mouseenter', function () {
    if ($(window).outerWidth() > 1024) {
      $header.removeClass('apply-transparency');
    }
  });
  $header.on('mouseleave', function () {
    if ($(window).scrollTop() === 0 && $(window).outerWidth() > 1024 && !$header.hasClass('force-opacity')) {
      $header.addClass('apply-transparency');
    }
  });

  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof (window.dAgency.showNewsletterPopUp) === 'function') window.dAgency.showNewsletterPopUp();
  });

  /* ==================== Search PopUp ==================== */
  const $searchBar = $header.find('.header__search-popup');
  if ($searchBar.length > 0) {
    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0) {
      $iconSearch.on('click', function (e) {
        e.preventDefault();
        $searchBar.toggleClass('open');

        if ($searchBar.hasClass('open')) {
          $header.removeClass('apply-transparency');
          $header.addClass('force-opacity');
          $searchBar.find('form input[type="text"]').trigger('focus');
        } else {
          $header.removeClass('force-opacity');
          if ($(window).scrollTop() === 0) {
            $header.addClass('apply-transparency');
          }
        }
      });
    }

    const $closeIcon = $searchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $searchBar.removeClass('open');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
      });
    }
  }

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  const $slideMobileMenu = $mobileMenu.find('[data-link-opener]:not(.dropdown-menu)');
  const $dropdownMobileMenu = $mobileMenu.find('[data-link-opener].dropdown-menu.has_children');
  if ($mobileMenu.length > 0) {

    $slideMobileMenu.on('click', function (e) {
      const drawerAttribute = $(this).data('link-opener');
      const $drawer = $(this).parent().find('[data-level="' + drawerAttribute + '"]');

      if ($drawer.length > 0) {
        $drawer.addClass('open');
      }
    });

    $dropdownMobileMenu.on('click', function (e) {
      const drawerAttribute = $(this).data('link-opener');
      const $drawer = $(this).parent().find('[data-level="' + drawerAttribute + '"]');

      if ($drawer.hasClass('open')) {
        $drawer.find(">div").slideUp(200);
        $drawer.removeClass('open');
        $(this).closest('li').removeClass('dropdown-menu-open');
      } else {
        $drawer.find('>div').slideDown(250);
        $drawer.addClass('open');
        $(this).closest('li').addClass('dropdown-menu-open');
      }
    });

    $mobileMenu.find('[data-close-level]').on('click', function () {
      $(this).parent().removeClass('open');
      clearMobileMenu($mobileMenu);
    });

    $header.find('.header__burger-icon').on('click', function () {
      $mobileMenu.addClass('open');
      $('html').css('overflow-y', 'hidden');
      $header.removeClass('apply-transparency');
      $header.addClass('force-opacity');

      if ($searchBar.length > 0) {
        $searchBar.removeClass('open');
      }
    });

    $mobileMenu.find('.header__mobile-menu__close-icon').on('click', function () {
      $mobileMenu.removeClass('open');
      $('html').css('overflow-y', '');
      $header.removeClass('force-opacity');
      if ($(window).scrollTop() === 0) {
        $header.addClass('apply-transparency');
      }
    });

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css('transform', 'translate3d(0, 0, 0)');
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on('click', function () {
      const $menu = $(this).closest('.header__mobile-menu__level');
      $menu.css('transform', '');
    });
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  if ($desktopMenu.length > 0) {
    const $inlineElements = $desktopMenu.find('.header__desktop-menu__inline-elements__link');
    $inlineElements.each(function () {
      $(this).on('mouseenter', function () {
        $(this).addClass('open');
        $header.addClass('force-opacity');
      });

      $(this).on('mouseleave', function () {
        $(this).removeClass('open');

        if ($searchBar.length > 0) {
          if (!$searchBar.hasClass('open')) {
            $header.removeClass('force-opacity');
          }
        } else {
          $header.removeClass('force-opacity');
        }
      });
    });
  }
});



function clearMobileMenu($mobileMenu) {
  $mobileMenu.find('.open').removeClass('open');
  $mobileMenu.find('div').removeAttr('style');
  $mobileMenu.find('.dropdown-menu-open').removeClass('dropdown-menu-open');
}


atQuery('max', 'lg', () => {
  const popupRadioIframe = document.querySelector('.radio__popup__iframe');
  const radioOpener = document.querySelector('.header__right__element.radio');
  const radioClose = document.querySelector('.radio__popup__background');

  if (radioOpener) {
    radioOpener.addEventListener('click', () => {
      popupRadioIframe.classList.add('active');
      radioClose.classList.add('active');
    });
  }

  if (radioClose) {
    radioClose.addEventListener('click', () => {
      popupRadioIframe.classList.remove('active');
      radioClose.classList.remove('active');
    });
  }
});

atQuery('min', 'md', () => {
  const radioOpener = document.querySelector('.header__right__element.radio a');
  if (radioOpener) {
    radioOpener.addEventListener('click', function (event) {
      event.preventDefault();

      var url = this.href;
      var width = 400;
      var height = 639;

      window.open(url, '_blank', 'width=' + width + ',height=' + height);
    });
  }
});
